export default __webpack_public_path__ + "static/media/inner-digital-ready-infrastructure.fa3eb4cd.svg";